const HYBRID_KEYWORDS = ['hybrid', 'hibrido', 'hybride']

/**
 * Vrai si le libellé d'énergie correspond à une énergie hybride
 * (Hybride, Hybride Diesel Électrique, hybrid, híbrido, …).
 * L'électrique seul n'est pas hybride.
 */
export function isHybridEnergie (energie) {
  const str = String(energie == null ? '' : energie)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')

  return HYBRID_KEYWORDS.some(keyword => str.includes(keyword))
}
